export default "__VITE_ASSET__BdlmXJDy__"